<template>
  <section class="feedback" :class="ui?.root">
    <div class="card" :class="ui?.card">
      <div>
        <div class="card-title" :class="ui?.cardTitle">
          Есть предложения по развитию или сотрудничеству?
        </div>
        <div class="card-description" :class="ui?.cardDescription">
          Напишите нам и мы свяжемся с вами в ближайшее время
        </div>
      </div>
      <FeedbackModal>
        <UButton class="h-10 min-w-32.5 max-md:w-full max-md:justify-center">
          Написать нам
        </UButton>
      </FeedbackModal>
    </div>

    <div class="card" :class="ui?.card">
      <div>
        <div class="card-title" :class="ui?.cardTitle">
          Спорт портал в социальных сетях
        </div>
        <div class="card-description" :class="ui?.cardDescription">
          Активно ведем и рассказываем много интересного
        </div>
      </div>

      <div class="flex gap-2 max-md:w-full max-md:justify-start">
        <a href="https://max.ru" target="_blank">
          <img src="~/assets/icons/max.svg" alt="max ссылка" />
        </a>
        <a href="https://vk.com" target="_blank">
          <img src="~/assets/icons/vk.svg" alt="vk ссылка" />
        </a>
        <a href="https://t.me" target="_blank">
          <img src="~/assets/icons/telegram.svg" alt="telegram ссылка" />
        </a>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import FeedbackModal from '~/components/modals/FeedbackModal.vue'

defineProps<{
  ui?: {
    root?: string
    card?: string
    cardTitle?: string
    cardDescription?: string
  }
}>()
</script>

<style lang="scss" scoped>
.feedback {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: calc(var(--spacing) * 2.5) /* 0.625rem = 10px */;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;

  @include max-lg {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  @include max-sm {
    padding-left: 8.5px;
    padding-right: 8.5px;
  }
}

.card {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 16px;
  padding: 28px;
  background-color: var(--color-white);
  gap: 20px;

  @include isLessThan('md') {
    flex-direction: column;
  }
}

.card-title {
  font-size: 16px;
  line-height: 1.375em;
  font-weight: 700;
  color: var(--color-neutral-default);
  margin-bottom: 6px;
}

.card-description {
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.3em;
  color: var(--color-neutral-light);
}
</style>
